import { Worker } from 'gql.generated'
import { IPersonaProps } from 'office-ui-fabric-react'

export function mapWorkerToUserPersonaMaybeArray(
  worker: Worker | Worker[] | undefined | null
): IPersonaProps[] {
  if (!worker) {
    return []
  }
  let workers: Worker[]

  Array.isArray(worker) ? (workers = worker) : (workers = [worker])

  return workers.map((w) => mapWorkerToUserPersona(w))
}

export const mapWorkerToUserPersona = (worker: Worker): IPersonaProps =>
  ({
    userId: worker._id,
    text: worker.name,
    secondaryText: worker.department,
    tertiaryText: worker.company,
  } as IPersonaProps)
